import React, { HTMLAttributes } from "react";
import Link from "next/link";
import cn from "classnames";
import styles from "../styles/general.module.css";

interface BreadcrumbsProps extends HTMLAttributes<HTMLDivElement> {
  items: Array<{ name: string; url?: string }>;
  hasTitle?: boolean;
}

export default function Breadcrumbs({
  items,
  hasTitle,
  className,
  ...containerProps
}: BreadcrumbsProps) {
  return (
    <div {...containerProps} className={cn(styles.breadcrumbs, className)}>
      {items.map(({ name, url }, index) => (
        <React.Fragment key={name + url}>
          {index ? <Arrow /> : null}
          {url ? (
            <Link href={url}>{name}</Link>
          ) : hasTitle ? (
            <h1>{name}</h1>
          ) : (
            <span>{name}</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

// #region

function Arrow() {
  return <span className={styles.breadcrumbsArrow}>›</span>;
}

// #endregion
